import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'modal-frame',
  templateUrl: './modal.frame.component.html',
  styleUrls: ['./modal.frame.component.scss']
})

export class ModalFrameComponent implements OnInit {

  @Input() option: string;
  @Output() closeModal = new EventEmitter();

  display: string;

  constructor(public translate: TranslateService) {
  }

  ngOnInit() {
    this.display = this.option;
  }

  close() {
    if (this.closeModal) {
      this.closeModal.emit();
    }
  }
}
